import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowRight, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';
import styles from '../Login/Login.module.css';
import axiosClient from '../../api/axiosClient';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axiosClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrap}>
      <Link to="/login" className={styles.backLink}>
        <FiArrowLeft /> Back to login
      </Link>

      <div className={styles.brandPanel}>
        <div className={styles.gridOverlay} />
        <div className={`${styles.blob} ${styles.blob1}`} />
        <div className={`${styles.blob} ${styles.blob2}`} />
        <div className={`${styles.blob} ${styles.blob3}`} />
        <div className={styles.brandContent}>
          <div className={styles.brandEyebrow}>Block Cost Technologies</div>
          <h2 className={styles.brandTitle}>
            Forgot your <span>password</span>? No problem.
          </h2>
          <p className={styles.brandSub}>
            Enter the email on your account and we'll send you a secure link to set a new password.
          </p>
        </div>
      </div>

      <div className={styles.formPanel}>
        <div className={styles.card}>
          <div className={styles.eyebrow}>BCT Platform</div>
          <h1 className={styles.title}>Reset your password</h1>
          <p className={styles.subtitle}>We'll email you a link to set a new one.</p>

          {error && <div className={styles.error}>{error}</div>}

          {sent ? (
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', color: 'var(--success)', background: 'rgba(79,174,122,.08)', border: '1px solid rgba(79,174,122,.3)', borderRadius: 12, padding: 18 }}>
              <FiCheckCircle size={20} style={{ flexShrink: 0, marginTop: 2 }} />
              <div>
                <b style={{ display: 'block', marginBottom: 4 }}>Check your inbox</b>
                <span style={{ color: 'var(--muted)', fontSize: 13.5 }}>
                  If an account exists for <b>{email}</b>, a reset link has been sent. It expires in 30 minutes.
                </span>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label className={styles.label}>Email</label>
                <div className={styles.inputWrap}>
                  <FiMail className={styles.inputIcon} />
                  <input
                    type="email"
                    className={styles.input}
                    placeholder="support@blockcostlabs.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <button type="submit" className={styles.submitBtn} disabled={loading}>
                {loading ? <span className={styles.spinner} /> : <>Send reset link <FiArrowRight /></>}
              </button>
            </form>
          )}

          <div className={styles.footer}>
            Remembered it? <Link to="/login">Back to login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
